import { render } from "./NotesInfo.vue?vue&type=template&id=cbd73a3e&scoped=true"
import script from "./NotesInfo.vue?vue&type=script&lang=js"
export * from "./NotesInfo.vue?vue&type=script&lang=js"

import "./NotesInfo.vue?vue&type=style&index=0&id=cbd73a3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd73a3e"]])

export default __exports__